import config from './config';
import getEnv from './env';

function getPath() {
  let pathObj = null;
  const envName = getEnv();
  const moduleName = window.location.pathname.substr(1).split('.')[0].split('/')[0].toLowerCase();

  // 判断模块，默认shop
  pathObj = config.module[moduleName] ? config.module[moduleName] : config.module.default;

  // 模块自定义配置
  const envObj = pathObj[envName] ? pathObj[envName] : config.env[envName];
  return {
    ajax: `${window.location.protocol}//${envObj.serverDomain}${pathObj.ajax}`,
    serverDomain: `${window.location.protocol}//${envObj.serverDomain}`,
  };
}

export default getPath;



// WEBPACK FOOTER //
// ./src/lib/path.js